import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Input,
  Dropdown
} from 'semantic-ui-react'

const CardPayrollRevenueAndDeductTabUX = (props: any) => {
    return(
      <div
        id="CardPayrollRevenueAndDeductUX-div-0"
        style={{paddingBottom: '40px'}}>

        <div
          id="CardPayrollRevenueAndDeductUX-div-1"
          style={{paddingLeft:'20px'}}>

          <div
            id="CardPayrollRevenueAndDeductTabUX-div-9"
            style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '20px', paddingBottom: 0, fontWeight: 'bold'}}>

            <div
              id="CardPayrollRevenueAndDeductUX-div-2"
              style={{ marginTop: '20px', fontWeight: 'bold' }}>
              {props.languageUX === "en" ? "Revenue & Deduct Details" : "รายละเอียดรายได้และการหักเงิน"}
            </div>
            <div
              id="CardPayrollRevenueAndDeductTabUX-div-10"
              style={{ display: 'flex', gap: '10px' }}>

              <div
                id="CardPayrollRevenueAndDeductTabUX-div-7">
                {props.renderAddRevenueButton()}
              </div>
              <div
                id="CardPayrollRevenueAndDeductTabUX-div-8">
                {props.renderAddDeductButton()}
              </div>
            </div>
          </div>
          <hr
            id="CardPayrollRevenueAndDeductUX-hr-3">
          </hr>
          <div
            id="CardPayrollRevenueAndDeductTabUX-div-4">

            <div
              id="CardPayrollRevenueAndDeductTabUX-div-27"
              style={{display: 'flex', marginTop: '10px'}}>

              <Button
                id="CardPayrollRevenueAndDeductTabUX-Button-5"
                onClick={props.onClickRevenueItem}
                style={props.getRevenueTabStyle}>
                {props.languageUX === "en" ? "Revenue Item" : "รายการรายได้"}
              </Button>
              <Button
                id="CardPayrollRevenueAndDeductTabUX-Button-6"
                onClick={props.onClickDeductItem}
                style={props.getDeductTabStyle}>
                {props.languageUX === "en" ? "Deduct Item" : "หักรายการ"}
              </Button>
            </div>
            <div
              id="CardPayrollRevenueAndDeductTabUX-div-28"
              style={{ height: '2px', backgroundColor: '#ccc', width: '100%' }}>

            </div>
            <div
              id="CardPayrollRevenueAndDeductTabUX-div-11"
              style={{display: "flex", justifyContent: "space-between", whiteSpace: "nowrap", padding: "20px 0" }}>

              <div
                id="CardPayrollRevenueAndDeductTabUX-div-12"
                style={{display: 'flex'}}>

                <div
                  id="CardPayrollRevenueAndDeductTabUX-div-14"
                  style={{ display: "flex", alignItems: "center" }}>

                  <label
                    id="CardPayrollRevenueAndDeductTabUX-label-17"
                    style={{paddingRight: '20px'}}>
                    {props.languageUX === "en" ? "Code" : "รหัส"}
                  </label>
                  <Input
                    icon="search"
                    id="CardPayrollRevenueAndDeductTabUX-Input-21"
                    onChange={props.handleFilterCodeChange}
                    placeholder="Search by Code"
                    value={props.filterCode}>
                  </Input>
                </div>
                <div
                  id="CardPayrollRevenueAndDeductTabUX-div-13"
                  style={{ display: "flex", alignItems: "center" }}>

                  <label
                    id="CardPayrollRevenueAndDeductTabUX-label-18"
                    style={{padding: '0 20px'}}>
                    {props.languageUX === "en" ? "Name" : "ชื่อ"}
                  </label>
                  <Input
                    icon="search"
                    id="CardPayrollRevenueAndDeductTabUX-Input-22"
                    onChange={props.handleFilterNameChange}
                    placeholder="Search by Name"
                    value={props.filterName}>
                  </Input>
                </div>
                <div
                  id="CardPayrollRevenueAndDeductTabUX-div-15"
                  style={{ display: "flex", alignItems: "center" }}>

                  <label
                    id="CardPayrollRevenueAndDeductTabUX-label-19"
                    style={{padding: '0 20px'}}>
                    {props.languageUX === "en" ? "Type" : "พิมพ์"}
                  </label>
                  <Dropdown
                    id="CardPayrollRevenueAndDeductTabUX-Dropdown-23"
                    onChange={props.handleFilterTypeChange}
                    options={props.revenueItemTypeOptions}
                    selection={true}
                    value={props.filterType}
                    text={props.handleTypeTextInDropdown}>
                  </Dropdown>
                </div>
                <div
                  id="CardPayrollRevenueAndDeductTabUX-div-16"
                  style={{ display: "flex", alignItems: "center" }}>

                  <label
                    id="CardPayrollRevenueAndDeductTabUX-label-20"
                    style={{padding: '0 20px'}}>
                    {props.languageUX === "en" ? "Status" : "สถานะ"}
                  </label>
                  <Dropdown
                    id="CardPayrollRevenueAndDeductTabUX-Dropdown-24"
                    onChange={props.handleFilterStatusChange}
                    options={props.revenueItemStatusOptions}
                    selection={true}
                    value={props.filterStatus}
                    text={props.handleStatusTextInDropdown}>
                  </Dropdown>
                </div>
              </div>
              <div
                id="CardPayrollRevenueAndDeductTabUX-div-29">
                {props.renderSearchButton}
              </div>
            </div>
            <div
              id="CardPayrollRevenueAndDeductTabUX-div-26">
              {props.itemsTable()}
            </div>
          </div>
        </div>
      </div>
    )
}


export default CardPayrollRevenueAndDeductTabUX

export const screenPropsDefault = {}

/* Date Time : Tue Aug 19 2025 09:26:52 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{paddingBottom: '40px'}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{paddingLeft:'20px'}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดรายได้และการหักเงิน",
          "valueEN": "Revenue & Deduct Details"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductUX-div-2"
        },
        "style": {
          "type": "code",
          "value": "{ marginTop: '20px', fontWeight: 'bold' }"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "hr",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductUX-hr-3"
        }
      },
      "seq": 8,
      "void": true
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-4"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "Button",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "รายการรายได้",
          "valueEN": "Revenue Item"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-Button-5"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickRevenueItem"
        },
        "style": {
          "type": "code",
          "value": "props.getRevenueTabStyle"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "Button",
      "parent": 27,
      "props": {
        "children": {
          "type": "value",
          "value": "หักรายการ",
          "valueEN": "Deduct Item"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-Button-6"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClickDeductItem"
        },
        "style": {
          "type": "code",
          "value": "props.getDeductTabStyle"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderAddRevenueButton()"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-7"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderAddDeductButton()"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-8"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 1,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex', justifyContent: 'space-between', alignItems: 'center', paddingTop: '20px', paddingBottom: 0, fontWeight: 'bold'}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{ display: 'flex', gap: '10px' }"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", whiteSpace: \"nowrap\", padding: \"20px 0\" }"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex'}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{ display: \"flex\", alignItems: \"center\" }"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "label",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "รหัส",
          "valueEN": "Code"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-label-17"
        },
        "style": {
          "type": "code",
          "value": "{paddingRight: '20px'}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "label",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "ชื่อ",
          "valueEN": "Name"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-label-18"
        },
        "style": {
          "type": "code",
          "value": "{padding: '0 20px'}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "label",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "พิมพ์",
          "valueEN": "Type"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-label-19"
        },
        "style": {
          "type": "code",
          "value": "{padding: '0 20px'}"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "label",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "สถานะ",
          "valueEN": "Status"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-label-20"
        },
        "style": {
          "type": "code",
          "value": "{padding: '0 20px'}"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Input",
      "parent": 14,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-Input-21"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleFilterCodeChange"
        },
        "placeholder": {
          "type": "value",
          "value": "Search by Code"
        },
        "value": {
          "type": "code",
          "value": "props.filterCode"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 22,
      "name": "Input",
      "parent": 13,
      "props": {
        "icon": {
          "type": "value",
          "value": "search"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-Input-22"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleFilterNameChange"
        },
        "placeholder": {
          "type": "value",
          "value": "Search by Name"
        },
        "value": {
          "type": "code",
          "value": "props.filterName"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Dropdown",
      "parent": 15,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-Dropdown-23"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleFilterTypeChange"
        },
        "options": {
          "type": "code",
          "value": "props.revenueItemTypeOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterType"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 24,
      "name": "Dropdown",
      "parent": 16,
      "props": {
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-Dropdown-24"
        },
        "onChange": {
          "type": "code",
          "value": "props.handleFilterStatusChange"
        },
        "options": {
          "type": "code",
          "value": "props.revenueItemStatusOptions"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.filterStatus"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.itemsTable()"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-26"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-27"
        },
        "style": {
          "type": "code",
          "value": "{display: 'flex', marginTop: '10px'}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-28"
        },
        "style": {
          "type": "code",
          "value": "{ height: '2px', backgroundColor: '#ccc', width: '100%' }"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "code",
          "value": "props.renderSearchButton"
        },
        "id": {
          "type": "value",
          "value": "CardPayrollRevenueAndDeductTabUX-div-29"
        }
      },
      "seq": 29,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 85,
  "name": "CardPayrollRevenueAndDeductTabUX",
  "project": "New Project",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
